import { css } from "@emotion/react";
import { CSS_MQ } from "../../../../../../styles/breakpoints";
import { fontSize } from "../../../../../../styles/fonts";

export const labelStyles = [
  fontSize.x2s,
  css`
    word-break: break-word;
    text-align: left;

    text-transform: uppercase;
  `,
];
